import React,{ useEffect, useState } from 'react';
import styles from './leaseRequestEdit.module.css';
import { Link, useLocation } from 'react-router-dom';
import {useSelector, useDispatch, connect} from 'react-redux';
import LeaseRequestEditTitle from './elems/titleBar/editTitleBar';
import LeaseRequestEditSidebar from './elems/sidebar/editSidebar';
import LeaseRequestGeneralEdit from './elems/generalEdit';
import { getObjectById, myLeaseRequestEdit } from '../../../../utils/endPoints';
import Loader from '../../../loader/loader';
import { getMyDraftLeaseRequest } from '../../../../utils/requests/requestsUtils'
import { auctionGetId } from '../../../../redux/actions/auctions/auctions';

const LeaseRequestEdit =( props )=> {
    const editPublished = props?.editPublished ?? false

    const token = useSelector(state => state.start.token);
    // const myRequestItem = useSelector(state => state.start.myRequest)
    const [myRequestItem, setMyRequestItem ] = useState(props.myRequest)
    const leaseObject = useSelector(state => state.start.auctionsGetId)
    const dispatch = useDispatch()
    const { pathname } = useLocation()
    const [ entitiesArr, setEntitiesArr ] = useState([])

    function reloadLeaseRequestDraft(){
        const id = pathname.split('/')[4]
        dispatch(getMyDraftLeaseRequest(myLeaseRequestEdit(id), token?.access_token))
    }

    useEffect(() => {
        if (editPublished) {
            let reqId = pathname.split('/').at(-1)
            let tmpToken = !!token ? `${token.access_token}` : null
            let objUrl = `${process.env.REACT_APP_END_POINT_BD}/api/v2/uk/private/request/${reqId}`
            let header = {'Content-Type': 'application/json', 'Authorization': tmpToken}
            // fetchData(objUrl, header, setMyRequestItem)
            fetchData(objUrl, header, (result) => {
                dispatch({type: 'REQUEST_GET_MY', payload: result})
                setMyRequestItem(result)
            })
        } else {
            reloadLeaseRequestDraft()
            setMyRequestItem(props.myRequest);
        }
        return () => {
            dispatch({type: 'REQUEST_GET_MY', payload: null})
        }
    }, [editPublished, pathname, token])

    if ((myRequestItem === null || myRequestItem?.length === 0) && editPublished == false && props.myRequest) {
        setMyRequestItem(props.myRequest);
    }

    // useEffect(() => {
    //     if (editPublished !== true) {
    //         const id = pathname.split('/')[4]
    //         dispatch(getMyDraftLeaseRequest(myLeaseRequestEdit(id), token?.access_token))
    //         // return () => {
    //         //     dispatch({type: 'REQUEST_GET_MY', payload: null})
    //         // }
    //     }
    // }, [editPublished, token])

    useEffect(() => {
      if ( !!myRequestItem?.relatedObjectId ) dispatch( auctionGetId( getObjectById( myRequestItem.relatedObjectId ) ) )

      return () => {
        dispatch({type: 'AUCTIONS_GET_ID', payload: null})
      }
    }, [myRequestItem])

    async function fetchData(url, header, action) {
        let result = await fetch(url, {
            method: 'GET',
            headers: header,
        }).then(response => {
            return response.json()
        })
            .catch(err => console.log(err))
        action(result)
        return result
    }

    function setGeneral(){
      if ( !!myRequestItem) return <LeaseRequestGeneralEdit data={ props.myRequest ?? myRequestItem } entitiesArr={ entitiesArr } />
      else return <Loader />
    }

    return (
        <div className={styles.wrap}>
            <LeaseRequestEditTitle data={ editPublished ? myRequestItem : props.myRequest } />
            <div className={styles.container}>
                <LeaseRequestEditSidebar data={ myRequestItem } object={ leaseObject } />
                { setGeneral() }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        myRequest: state.start.myRequest,
    };
};

// export default LeaseRequestEdit
export default connect(mapStateToProps)(LeaseRequestEdit);
